// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import auditTeamMemberEntity from './entities/audit-team-member.json';
import auditTeamMemberMenu from '../pages/audit-team-member/menu.json';
import auditTeamMemberFullForm from '../pages/audit-team-member/forms/full.json';
import auditTeamMemberContextForm from '../pages/audit-team-member/forms/context.json';
import auditTeamMemberMiniForm from '../pages/audit-team-member/forms/mini.json';
import auditTeamMemberLookupForm from '../pages/audit-team-member/forms/lookup.json';
import auditTeamMemberTableView from '../pages/audit-team-member/views/table.json';
import auditTeamMemberCardsView from '../pages/audit-team-member/views/cards.json';
import auditTeamMemberCalendarView from '../pages/audit-team-member/views/calendar.json';
import auditTeamMemberDashboardView from '../pages/audit-team-member/views/dashboard.json';

/** Тип запису «Член аудиторської групи» зі сторінками пакета: меню, форми та подання з pages/audit-team-member/. */
export const auditTeamMemberDefinition: IRecordTypeDefinition = {
  ...auditTeamMemberEntity,
  views: assembleViewSet({
      table: auditTeamMemberTableView,
      cards: auditTeamMemberCardsView,
      calendar: auditTeamMemberCalendarView,
      dashboard: auditTeamMemberDashboardView,
  }),
  form: auditTeamMemberFullForm,
  forms: { full: auditTeamMemberFullForm, context: auditTeamMemberContextForm, mini: auditTeamMemberMiniForm, lookup: auditTeamMemberLookupForm },
  menu: auditTeamMemberMenu,
} as IRecordTypeDefinition;
